import Cookies from 'js-cookie'

const TokenKey = 'Larke-Admin-Token'
const TokenExpiresInKey = 'Larke-Admin-Expires-In'
const RefreshTokenKey = 'Larke-Admin-Refresh-Token'

export function getToken(type = 'local') {
  // eslint-disable-next-line eqeqeq
  if (type == 'local') {
    return localStorage.getItem(TokenKey) || ''
  // eslint-disable-next-line eqeqeq
  } else if (type == 'session') {
    return sessionStorage.getItem(TokenKey) || ''
  } else {
    return Cookies.get(TokenKey)
  }
}

export function setToken(token, type = 'local') {
  // eslint-disable-next-line eqeqeq
  if (type == 'local') {
    return localStorage.setItem(TokenKey, token)
  // eslint-disable-next-line eqeqeq
  } else if (type == 'session') {
    return sessionStorage.setItem(TokenKey, token)
  } else {
    return Cookies.set(TokenKey, token)
  }
}

export function removeToken(type = 'local') {
  // eslint-disable-next-line eqeqeq
  if (type == 'local') {
    return localStorage.removeItem(TokenKey)
  // eslint-disable-next-line eqeqeq
  } else if (type == 'session') {
    return sessionStorage.removeItem(TokenKey)
  } else {
    return Cookies.remove(TokenKey)
  }
}

export function getTokenExpiresIn(type = 'local') {
  // eslint-disable-next-line eqeqeq
  if (type == 'local') {
    return localStorage.getItem(TokenExpiresInKey) || ''
  // eslint-disable-next-line eqeqeq
  } else if (type == 'session') {
    return sessionStorage.getItem(TokenExpiresInKey) || ''
  } else {
    return Cookies.get(TokenExpiresInKey)
  }
}

export function setTokenExpiresIn(time, type = 'local') {
  // eslint-disable-next-line eqeqeq
  if (type == 'local') {
    return localStorage.setItem(TokenExpiresInKey, time)
  // eslint-disable-next-line eqeqeq
  } else if (type == 'session') {
    return sessionStorage.setItem(TokenExpiresInKey, time)
  } else {
    return Cookies.set(TokenExpiresInKey, time)
  }
}

export function removeTokenExpiresIn(type = 'local') {
  // eslint-disable-next-line eqeqeq
  if (type == 'local') {
    return localStorage.removeItem(TokenExpiresInKey)
  // eslint-disable-next-line eqeqeq
  } else if (type == 'session') {
    return sessionStorage.removeItem(TokenExpiresInKey)
  } else {
    return Cookies.remove(TokenExpiresInKey)
  }
}

export function getRefreshToken(type = 'local') {
  // eslint-disable-next-line eqeqeq
  if (type == 'local') {
    return localStorage.getItem(RefreshTokenKey) || ''
  // eslint-disable-next-line eqeqeq
  } else if (type == 'session') {
    return sessionStorage.getItem(RefreshTokenKey) || ''
  } else {
    return Cookies.get(RefreshTokenKey)
  }
}

export function setRefreshToken(token, type = 'local') {
  // eslint-disable-next-line eqeqeq
  if (type == 'local') {
    return localStorage.setItem(RefreshTokenKey, token)
  // eslint-disable-next-line eqeqeq
  } else if (type == 'session') {
    return sessionStorage.setItem(RefreshTokenKey, token)
  } else {
    return Cookies.set(RefreshTokenKey, token)
  }
}

export function removeRefreshToken(type = 'local') {
  // eslint-disable-next-line eqeqeq
  if (type == 'local') {
    return localStorage.removeItem(RefreshTokenKey)
  // eslint-disable-next-line eqeqeq
  } else if (type == 'session') {
    return sessionStorage.removeItem(RefreshTokenKey)
  } else {
    return Cookies.remove(RefreshTokenKey)
  }
}
